module.exports = __webpack_public_path__ + "img/serveItem3.47cb41af.png";